<template>

  <a-dropdown placement="bottomRight" class="loginBox">
    <a-button v-if="Object.keys(userInfo).length > 0 && userInfo.phone">
      <a-icon type="user" />{{ userInfo.phone }}</a-button
      >
    <a-menu slot="overlay">
      <a-menu-item>
        <router-link :to="{path:''}">账号信息</router-link>
      </a-menu-item>
      <!-- <a-menu-item>
        <router-link :to="{path:''}">资产管理</router-link>
      </a-menu-item> -->
      <a-menu-item>
        <router-link :to="{path:'/user/resetPassword'}">修改密码</router-link>
      </a-menu-item>
      <a-menu-item>
        <a rel="noopener noreferrer" @click="logout">退出登录</a>
      </a-menu-item>
      <!-- <a-menu-item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.taobao.com/"
          >2nd menu item</a
        >
      </a-menu-item>
      <a-menu-item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.tmall.com/"
          >3rd menu item</a
        >
      </a-menu-item> -->
    </a-menu>
  </a-dropdown>

</template>

<script>
import { mapActions } from 'vuex'
export default {
  // 信息从vuex中获取
  data () {
    return {}
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    // console.log(this.$store.state.user.userInfo)
    // this.userInfo = this.$store.state.user.userInfo
  },
  methods: {
    ...mapActions(['Logout']),
    logout () {
      this.Logout()
      setTimeout(() => {
        this.$router.replace('/user/login')
      }, 1500)
    }
  }
}
</script>

<style>
</style>
